module.exports = __webpack_public_path__ + "assets/img/logo_gys.3d47e905.png";